export const gMapsAddressHandler = (
  mode: 'city' | 'address',
  place: google.maps.places.PlaceResult,
) => {
  if (mode === 'city' && place.address_components) {
    const city = place.address_components.find((el) => el.types.includes('locality'))?.short_name
      ? place.address_components.find((el) => el.types.includes('locality'))?.short_name
      : ''
    const region = place.address_components.find((el) =>
      el.types.includes('administrative_area_level_1'),
    )?.short_name
      ? place.address_components.find((el) => el.types.includes('administrative_area_level_1'))
          ?.short_name
      : ''
    const space = place.address_components.find((el) =>
      el.types.includes('administrative_area_level_1'),
    )?.short_name
      ? `, `
      : ''
    if (city === region) return {text:`${city}`, error:false}
    return { text: `${city}${space}${region}`, error: false }
  }
  if (mode === 'address' && place.address_components) {
    const street = place.address_components.find((el) => el.types.includes('route'))?.short_name
      ? place.address_components.find((el) => el.types.includes('route'))?.short_name
      : ''
    const houseNumber = place.address_components.find((el) => el.types.includes('street_number'))
      ?.short_name
      ? `, ${place.address_components.find((el) => el.types.includes('street_number'))?.short_name}`
      : ''
    return { text: `${street}${houseNumber}`, error: Boolean(houseNumber) }
  }
  return {text:'', error:false}
}
